import React from 'react'
import AddDailyFuelDataModal from './AddDailyFuelDataModal'
import { DailyMovementReportRecord, DmrFuelDataRow } from '../core/_dmrModels'

export interface FuelDataRecord {
  id: number;
  reportDate: string;
  vesselId: number;
  vesselName: string;
  reportType?: string;
  fuelRows?: Array<{
    engine: string;
    consumption: string;
    lastRunningHours: string;
    openingRunningHours: string;
    closingRunningHours: string;
    runningHours: string;
    average: string;
  }>;
  lubeRows?: Array<{
    grades: string;
    openingStock: string;
    received: string;
    consumedByVessel: string;
    closingStock: string;
  }>;
  openingStock: string;
  totalConsumption?: string;
  bunker?: string;
  closingStock: string;
  lastRunningHours?: string;
  totalRunningHours?: string;
  meCons: string;
  hydEngineCons: string;
  dredgeEngineCons: string;
  aeCons: string;
  harborDgCons: string;
  btCons: string;
  totalFoCons: string;
  dfdRemarks?: string;
  remarks: string;
}

interface DailyFuelDataProps {
  selectedVessel: string
  reportDate: string
  dmrRecord: DailyMovementReportRecord
  setDmrRecord: React.Dispatch<React.SetStateAction<DailyMovementReportRecord>>
  previousReport?: FuelDataRecord | null
}

const DailyFuelData: React.FC<DailyFuelDataProps> = ({ selectedVessel, reportDate: pageReportDate, dmrRecord, setDmrRecord, previousReport }) => {
  const effectiveSelectedVessel = selectedVessel

  const handleSaveData = (data: FuelDataRecord) => {
    // Map the local form data to the unified DMR fuel data state
    const mappedFuelRows: DmrFuelDataRow[] = (data.fuelRows || []).map(r => ({
      engine: r.engine,
      consumption: parseFloat(r.consumption) || 0,
      lastRunningHours: r.lastRunningHours || '',
      openingRunningHours: r.openingRunningHours || '',
      closingRunningHours: r.closingRunningHours || '',
      runningHours: parseFloat(r.openingRunningHours || r.runningHours) || 0,
      average: parseFloat(r.average) || 0
    }))

    setDmrRecord(prev => ({
      ...prev,
      fuelRows: mappedFuelRows,
      lubeRows: data.lubeRows || [],
      openingStockLtr: parseFloat(data.openingStock) || 0,
      bunkerLtr: parseFloat(data.bunker || '0') || 0,
      closingStockLtr: parseFloat(data.closingStock) || 0,
      totalFoCons: parseFloat(data.totalFoCons || '0') || 0,
      dfdOpeningStock: data.openingStock,
      dfdTotalConsumption: data.totalConsumption || data.totalFoCons || '0',
      dfdBunker: data.bunker || '0',
      dfdClosingStock: data.closingStock,
      dfdLastRunningHrs: data.lastRunningHours || '',
      dfdTotalRunningHrs: data.totalRunningHours || '',
      dfdRemarks: data.dfdRemarks ?? data.remarks ?? '',
    }))
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0 d-flex justify-content-between align-items-center pt-5 pb-4'>
        <div className='card-title m-0'>
          <h3 className='fw-bold m-0'>Daily Fuel Data</h3>
        </div>
        <div className='d-flex align-items-center gap-4 flex-wrap'>
          <div className='d-flex align-items-center gap-2'>
            <label className='form-label mb-0 fw-bolder text-muted fs-7 text-uppercase' style={{ whiteSpace: 'nowrap' }}>Vessel:</label>
            <span className='fw-bolder text-dark me-3'>
              {effectiveSelectedVessel || 'Select vessel in Vessel Status'}
            </span>
          </div>
        </div>
      </div>
      
      <AddDailyFuelDataModal
        onSave={handleSaveData}
        selectedVessel={effectiveSelectedVessel}
        reportDate={pageReportDate}
        previousReport={previousReport ?? null}
        currentDraft={dmrRecord}
      />
      
    </div>
  )
}

export default DailyFuelData
